import { combineReducers } from 'redux';

import alert from './alert';
import loader from './loader';
import breadcrumb from './breadcrumb';

import auth from './auth';
import dashboard from './dashboard';
import clientes from './clientes';
import asesorias from './asesorias';
import solicitudes_wa from './solicitudes_wa';
import usuarios from './usuarios';
import reportes from './reportes';
import configuracion from './configuracion';

export default combineReducers({
    alert, loader, breadcrumb, auth, dashboard, clientes, asesorias, solicitudes_wa, usuarios, reportes, configuracion
});